import { IBundleProduct } from "../entities/manhattan/bundle/types";
import BundleProductCharacteristicService from "./BundleProductCharacteristicService";
import BundleProductConfigurationService from "./BundleProductConfigurationService";

export default class BundleProductService {

  private static instance: BundleProductService;
  private bundleProduct: IBundleProduct;
  private readonly bundleProductConfigurationService: BundleProductConfigurationService;
  private readonly bundleProductCharacteristicService: BundleProductCharacteristicService;

  private constructor() {
    this.bundleProductConfigurationService = BundleProductConfigurationService.getInstance();
    this.bundleProductCharacteristicService = BundleProductCharacteristicService.getInstance();
  }

  public static getInstance(): BundleProductService {
    if (!this.instance) {
      this.instance = new BundleProductService();
    }

    return this.instance;
  }

  public init(bundleProduct: IBundleProduct): void {
    this.bundleProduct = bundleProduct;
    this.bundleProductConfigurationService.setBundleProductConfigurations(this.bundleProduct.bundleProductConfigurations);
    this.bundleProductCharacteristicService.setBundleProductCharacteristics(this.bundleProduct.product.productCharacteristics);
  }

  public getBundleProduct(): IBundleProduct {
    return this.bundleProduct;
  }

  public getBundleProductNumberOfAdditionalDevices() {
    return this.bundleProductConfigurationService.getNumberOfAdditionalDevicesFromConfiguration();
  }

  public getBundleProductMinimumDevices() : number {
    return this.bundleProductConfigurationService.getMinimumDevicesFromConfiguration();
  }

  public getBundleProductMaximumDevices() : number {
    return this.bundleProductConfigurationService.getMaximumDevicesFromConfiugarition();
  }

  public getSpecification() {
    return this.bundleProductCharacteristicService.createSpecification();
  }


}
